import TTransfer from './transfer.vue'

TTransfer.install = Vue => {
  Vue.component(TTransfer.name, TTransfer)
}

export default TTransfer



// WEBPACK FOOTER //
// ./src/module/transfer/index.js